import { useState } from 'react';
import { Button } from '@mui/material';
import { PiCaretRightBold } from 'react-icons/pi';
import { ApiRequest } from 'GlobalFunctions';
import { enqueueSnackbar } from 'notistack';

interface ResumeSubscriptionProps {
    subscriptionData: any;
    onGoBack: () => void;
    onResumeSuccess: () => void;
}

const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric',
        timeZone: 'UTC'
    });
};

export default function ResumeSubscription(props: ResumeSubscriptionProps) {
    const { subscriptionData, onGoBack, onResumeSuccess } = props;
    const [loading, setLoading] = useState(false);

    const handleResumeSubscription = () => {
        setLoading(true);
        
        ApiRequest({
            url: '/subscriptions/resume',
            method: 'POST',
            body: {
                subscription_id: subscriptionData?.subscription_id
            },
            setResponse: (response: any) => {
                setLoading(false);
                
                if (response.status === 'success') {
                    enqueueSnackbar('Subscription resumed successfully', { variant: 'success' });
                    onResumeSuccess();
                } else {
                    enqueueSnackbar(response.message || 'Error resuming subscription', { variant: 'error' });
                }
            }
        });
    };

    return (
        <div className="pc-cancel-subscription">
            <div className="pc-cancel-breadcrumb">
                <span>BILLING</span>
                <PiCaretRightBold />
                <span>RESUME</span>
            </div>

            <div className="pc-update-form">
                <h1 className="pc-cancel-title">Resume Your Subscription</h1>

                <div className="pc-cancel-product-info">
                    <div className="pc-cancel-product-name">{subscriptionData?.products?.[0]?.product_name}</div>
                    <div className="pc-cancel-product-price">USD${subscriptionData?.total_amount} per {subscriptionData?.products?.[0]?.frequency?.toLowerCase()?.replace('ly', '')}</div>
                </div>

                <div className="pc-cancel-message">
                    <p>Proceeding will remove the cancellation. The subscription remains active and will auto-renew on {formatDate(subscriptionData?.latest_next_payment_date)}.</p>
                </div>

                <div className="pc-cancel-actions">
                    <Button
                        variant="contained"
                        className="pc-cancel-btn-confirm"
                        onClick={handleResumeSubscription}
                        disabled={loading}
                        fullWidth
                        style={{
                            backgroundColor: subscriptionData?.primary_color || '#303030',
                            color: '#fff',
                            borderRadius: '10px',
                            padding: '10px 40px',
                            fontSize: '16px',
                            textTransform: 'none',
                        }}
                    >
                        {loading ? 'Processing...' : 'Resume Subscription'}
                    </Button>

                    <Button
                        variant="outlined"
                        className="pc-cancel-btn-goback"
                        onClick={onGoBack}
                        fullWidth
                        style={{
                            borderColor: subscriptionData?.primary_color || '#303030',
                            color: subscriptionData?.primary_color || '#303030',
                            borderRadius: '10px',
                            padding: '10px 40px',
                            fontSize: '16px',
                            textTransform: 'none',
                            marginTop: '15px'
                        }}
                    >
                        Go back
                    </Button>
                </div>
            </div>
        </div>
    );
}
